/**
 * Portal Manta · AjudaPage
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { S } from '../../globals.js';
import { GuiaPage } from './GuiaPage.jsx';
import { GlossarioPage } from './GlossarioPage.jsx';

const AjudaPage = memo(function AjudaPage_Inner(){
  const [aba, setAba] = useState('tour');
  return (<div style={S.page}>
    <div style={S.h1}>❓ 09 · Tour & Glossário</div>
    <div style={S.sub}>Padrão 12.5 da arquitetura Manta · navegação guiada do portal + glossário técnico</div>

    {/* Sub-abas */}
    <div style={{display:'flex', gap:0, marginBottom:14, background:'#fff', border:`1px solid ${M.border}`, borderRadius:6, overflow:'hidden'}}>
      {[
        {k:'tour',      n:'09.1', l:'Tour & Guia do Portal', ic:'🧭'},
        {k:'glossario', n:'09.2', l:'Glossário Técnico',     ic:'📔'},
      ].map(t=>(
        <button key={t.k} onClick={()=>setAba(t.k)} style={{
          flex:1, padding:'10px 16px', fontSize:11.5, fontWeight:700,
          background:aba===t.k?M.accent:'transparent', color:aba===t.k?'#fff':M.text,
          border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8,
          fontFamily:F.body,
        }}>
          <span style={{fontFamily:F.mono, fontSize:9.5, opacity:0.8}}>{t.n}</span>
          <span style={{fontSize:14}}>{t.ic}</span>
          <span>{t.l}</span>
        </button>
      ))}
    </div>

    <div style={{background:'#fff', borderRadius:8, border:`1px solid ${M.border}`, overflow:'hidden'}}>
      {aba==='tour'      && <GuiaPage/>}
      {aba==='glossario' && <GlossarioPage/>}
    </div>
  </div>);
});

export { AjudaPage };
export default AjudaPage;
